import {Component, OnInit} from '@angular/core';
import {SynopticElementModifier} from '../../../../../../model/synoptics/synoptic-configuration-types';
import {StyleByThresholdsArgs, StyleThreshold} from '../../../../../../model/synoptics/synoptic-arg-types';
import {SelectItem} from 'primeng/api';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-synoptics-form-state-modifier',
  templateUrl: './synoptics-form-state-modifier.component.html',
  styleUrls: ['./synoptics-form-state-modifier.component.scss']
})
export class SynopticsFormStateModifierComponent implements OnInit {

  public modifier: SynopticElementModifier;

  public availableThresholdAttributes: SelectItem[];
  public availableContinuousAttributes: SelectItem[];
  public conversionFactorOptions: SelectItem[];

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.availableThresholdAttributes = [
      { label: 'attribute.backgroundColor', value: 'backgroundColor'},
      { label: 'attribute.widthPercentage', value: 'widthPercentage'},
      { label: 'attribute.heightPercentage', value: 'heightPercentage'},
      { label: 'attribute.visibility', value: 'visibility'},
    ];
    this.availableContinuousAttributes = [
      { label: 'attribute.backgroundColor', value: 'backgroundColor'},
      { label: 'attribute.widthPercentage', value: 'widthPercentage'},
      { label: 'attribute.heightPercentage', value: 'heightPercentage'},
      { label: 'attribute.opacityPercentage', value: 'opacityPercentage'}
    ];
    this.conversionFactorOptions = [
      { label: 'misc.arithmeticOperations.addition', value: 'addition' },
      { label: 'misc.arithmeticOperations.subtraction', value: 'subtraction' },
      { label: 'misc.arithmeticOperations.multiplication', value: 'multiplication' },
      { label: 'misc.arithmeticOperations.division', value: 'division' }
    ];
    this.loadInputs(config.data);
  }

  ngOnInit(): void {
  }

  public addThreshold(thresholds: StyleThreshold[]): void {
    thresholds.push({
      from: 0,
      to: 1,
      backgroundColor: '#407ec9',
      widthPercentage: 100,
      heightPercentage: 100,
      opacityPercentage: 100,
      visible: true
    });
  }

  public addDefaultThreshold(args: StyleByThresholdsArgs): void {
    args.defaultStyle = {
      backgroundColor: '#407ec9',
      widthPercentage: 100,
      heightPercentage: 100,
      opacityPercentage: 100,
      visible: true
    };
  }

  public removeDefaultThreshold(args: StyleByThresholdsArgs): void {
    args.defaultStyle = null;
  }

  public removeThreshold(threshold: StyleThreshold, args: StyleByThresholdsArgs): void {
    args.thresholds = args.thresholds.filter(t => t != threshold);
  }

  private loadInputs(data: any): void {
    this.modifier = data.modifier;
    if (this.modifier.type === 'styleByContinuousValue') {
      if (this.modifier.args.widthPercentageRange === undefined) {
        this.modifier.args.widthPercentageRange = [0, 100];
      }
      if (this.modifier.args.heightPercentageRange === undefined) {
        this.modifier.args.heightPercentageRange = [0, 100];
      }
      if (this.modifier.args.opacityPercentageRange === undefined) {
        this.modifier.args.opacityPercentageRange = [0, 100];
      }
    }
  }

}
